import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import {
    firstBlockOverlapsNav,
    isOverlapBlockType,
} from "../components/HeaderNav/overlap";
import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";
import { SuiteBuilder } from "../components/SuiteBuilder";
import { ProductContextProvider } from "../components/SuiteBuilder/ProductContext/ProductContext";

export const Template = (props: templates.SuiteBuilderPageTemplate) => (
    <PageSkeleton
        {...props.page}
        overlapNav={firstBlockOverlapsNav(
            props.page.body.value.slice(0, 1).find(isOverlapBlockType),
        )}
    >
        <StreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={{
                ...toolboxComponents,
                suite_builder_content: () => (
                    <ProductContextProvider>
                        <SuiteBuilder />
                    </ProductContextProvider>
                ),
            }}
        />
    </PageSkeleton>
);
